import {
  Box,
  Button,
  HStack,
  Stack,
  StackDivider,
  Text,
  Link as ChakraLink
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';

const CTA = () => (
  <Box bg='gray.800' p={[6, 10]} borderRadius='xl' my={10}>
    <Stack
      direction={['column', 'column', 'row']}
      spacing={[8, 8, 16]}
      divider={<StackDivider borderColor='whiteAlpha.100' />}
    >
      <Stack direction='column' spacing={4}>
        <Text fontSize='xl' fontWeight='600'>
          Launch your own reward program
        </Text>
        <Text color='gray.300'>
          Gain access to thousands of Crucible holders by launching your reward
          program on our platform, saving you development time and costs.
          Launching a reward program is permissionless and we've got a host of
          different options available to suit your requirements.
        </Text>
        <HStack>
          <Button width='fit-content' as={Link} to='/onboarding'>
            + Create Program
          </Button>

          <Button
            width='fit-content'
            as={ChakraLink}
            variant='outline'
            isExternal
            href='https://docs.crucible.wtf/launching-a-reward-program/getting-started'
          >
            Read the Docs
          </Button>
        </HStack>
      </Stack>
      <Stack direction='column' spacing={4}>
        <Text fontSize='xl' fontWeight='600'>
          Join the community
        </Text>
        <Text color='gray.300'>
          We've got a super active community consisting of over 20,000
          Alchemists! There's loads going on and many ways to join in. We've
          even got our own chaos lab where you can experiment to your heart's
          content. Come in and get involved with the experiments, you may even
          get rewarded for exceptional ideas or content.
        </Text>
        <Button
          width='fit-content'
          as={ChakraLink}
          isExternal
          href='http://discord.alchemist.wtf'
        >
          Join Discord
        </Button>
      </Stack>
    </Stack>
  </Box>
);

export default CTA;
